import React from "react";
import { Eye, Sparkles } from "lucide-react";
import TemplateRenderer from "@/components/resume-builder/templates/TemplateRenderer";
import { SAMPLE_RESUME_DATA } from "@/data/galleryTemplates";

const BADGE_CLASS = { Popular: "bg-indigo-500", New: "bg-emerald-500" };

export default function TemplateCard({ template, onPreview, onUse }) {
  return (
    <div
      onClick={() => onPreview(template)}
      data-testid={`gallery-template-card-${template.id}`}
      className="group relative bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 cursor-pointer"
    >
      {template.badge && (
        <span className={`absolute top-2 left-2 z-10 text-[10px] font-bold uppercase px-2 py-0.5 rounded-full text-white ${BADGE_CLASS[template.badge]}`}>
          {template.badge}
        </span>
      )}

      <div className="h-64 overflow-hidden bg-slate-100 relative">
        <div className="absolute top-0 left-0 origin-top-left scale-[0.4] w-[700px] pointer-events-none">
          <TemplateRenderer templateId={template.id} colorId={template.colorId} draft={SAMPLE_RESUME_DATA} />
        </div>
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/45 transition-colors flex items-center justify-center gap-2 opacity-0 group-hover:opacity-100">
          <button
            onClick={(e) => { e.stopPropagation(); onPreview(template); }} data-testid={`gallery-preview-btn-${template.id}`}
            className="flex items-center gap-1.5 bg-white text-slate-900 text-xs font-semibold px-3 py-1.5 rounded-full hover:bg-slate-100"
          >
            <Eye className="w-3.5 h-3.5" /> Preview
          </button>
          <button
            onClick={(e) => { e.stopPropagation(); onUse(template); }} data-testid={`gallery-use-btn-${template.id}`}
            className="flex items-center gap-1.5 bg-indigo-500 text-white text-xs font-semibold px-3 py-1.5 rounded-full hover:bg-indigo-400"
          >
            <Sparkles className="w-3.5 h-3.5" /> Use Template
          </button>
        </div>
      </div>

      <div className="p-3.5 bg-[#12141c]">
        <p className="text-sm font-semibold text-white">{template.name}</p>
        <p className="text-xs text-slate-400 mt-0.5">{template.style} · {template.roleLevel.join("/")}</p>
      </div>
    </div>
  );
}
